import EmailListInput from './presenter';

export default EmailListInput;
